import React from "react";
import "./style.scss";
import { Link } from "react-router-dom";
const Paginate = ({ data }) => {
  // href={`?page=${+active == +lastPage ? +active : +active + 1}`}
  const render = link => {
    switch (link.label) {
      case "&laquo; قبلی":
        return (
          <Link
            to={`?page=${
              +data.current_page === 1
                ? +data.current_page
                : +data.current_page - 1
            }`}
          >
            <li>
              <img src={require("../../Assets/icons/Prev.png")} alt="Prev" />
            </li>
          </Link>
        );

      case "بعدی &raquo;":
        return (
          <Link
            to={`?page=${
              +data.current_page === +data.total
                ? +data.current_page
                : +data.current_page + 1
            }`}
          >
            <li>
              <img src={require("../../Assets/icons/Next.png")} alt="Next" />
            </li>
          </Link>
        );
      default:
        return (
          <Link to={`?page=${link.label}`}>
            <li
              style={{ whiteSpace: "nowrap" }}
              className="fs-13 lh-22 fw-500"
              data-active={link.active}
            >
              {link.label}
            </li>
          </Link>
        );
    }
  };
  return (
    <div className="paginate-wrapper">
      <ul>
        {data.links.map((item, key) => {
          return render(item);
        })}
      </ul>
    </div>
  );
};

export default Paginate;
